import React, { useState } from "react";
import Image from "components/image";
import Link from "components/link";
import Collapsible from "components/collapsible";
import clsx from "clsx/lite";
import { Swiper, SwiperSlide } from "components/swiper";
import { Navigation, Mousewheel } from "swiper/modules";
import { ReactComponent as Arrow } from "svgs/small-right-arrow.svg";

const CollectionsAccordions = ({ data }) => {
	const [activeAccordionKey, setActiveAccordionKey] = useState(data.groups[0]._key);
	const isFluid = data?.settings?.isFluid;

	const setActiveAccordion = (key) => {
		setActiveAccordionKey((prev) => prev !== key ? key : null);
	};

	return (
		<div className="w-full flex justify-center">
			<div className="w-full standard-section-width">
				{data.groups.map((accordion, index) => {
					const isSlider = accordion?.items?.length > 1;

					const swiperSettings = isSlider
						? {
							modules: [Navigation, Mousewheel],
							slidesPerView: 1.3,
							speed: 800,
							spaceBetween: 16,
							mousewheel: {
								enabled: true,
								forceToAxis: true,
							},
							navigation: {
								enabled: true,
								nextEl: ".right-arrow-an",
								prevEl: ".left-arrow-an",
								disabledClass: "opacity-0",
							},
							breakpoints: {
								480: {
									slidesPerView: 2,
								},
								680: {
									slidesPerView: 2.5,
								},
								1000: {
									slidesPerView: 3,
								}
							}
						}
						: {};
					return (
						<div key={accordion._key}
							className={clsx("border-b border-grey last:border-0", index === 0 ? "pb-6" : "py-6")}>
							<Collapsible
								title={<h3>{accordion.title}</h3>}
								titleClass={isFluid ? "horizontal-padding" : ""}
								isOpen={activeAccordionKey === accordion._key}
								setIsOpen={() => setActiveAccordion(accordion._key)}
								arrowIcons={false}
								label={accordion.title}
							>
								<div
									id={`accordion-content-${accordion._key}`}
									className={clsx(
										"flex flex-col gap-5 overflow-hidden transition-all duration-500 ease-in-out",
										activeAccordionKey !== accordion._key ? "max-h-0 opacity-0" : "max-h-144 opacity-1",
									)}
								>
									<p className={clsx("text-secondary", isFluid && "horizontal-padding")}>
										{accordion.description}
									</p>
									<div className={isFluid && "horizontal-padding"}>
										<Swiper {...swiperSettings} className={clsx("flex gap-6 overflow-auto no-scrollbar")}>
											{accordion?.items?.map((item, index) => (
												<SwiperSlide key={index} className="sm:min-w-72 w-3/4 sm:w-[40%] lg:w-1/3 mr-4">
													<Link key={index} to={`/collections/${item.collection?.handle?.current}`}
														className="group/card min-w-72"
														tabIndex={activeAccordionKey !== accordion._key ? "-1" : "0"}>
														<div className="relative overflow-hidden w-full">
															<div className="collection-accordion-content swiper-content-overlay">
																<h4 className="text-white">
																	{item.title ?? item.collection?.title}
																</h4>
															</div>
															<Image
																image={item.collection?.image}
																className={
																	clsx(item.hoverImage ?
																		"img-transition" :
																		"img-transition-scale")}
															/>
															{item.hoverImage &&
																<Image
																	className={
																		clsx("hidden md:flex !absolute top-0 right-0 bottom-0",
																			"left-0 opacity-0 img-transition-scale")}
																	image={item.hoverImage}
																/>
															}
														</div>
													</Link>
												</SwiperSlide>
											))}
											<div className="left-arrow-an size-10 md:!left-2">
												<Arrow className="rotate-180 scale-150 fill-white" />
											</div>
											<div className="right-arrow-an size-10 rounded-full md:!right-2">
												<Arrow className="scale-150 fill-white" />
											</div>
										</Swiper>
									</div>
								</div>
							</Collapsible>
						</div>
					);
				})}
			</div >
		</div >
	);
};

export default CollectionsAccordions;